export const MODE_NEW = "new";
export const MODE_REMOVE = "remove";
export const MODE_DOWNLOAD = "download";
